// ═══════════════════════════════════════════════════════════════
// BackButton — bouton retour unifié pour tous les écrans
// ═══════════════════════════════════════════════════════════════
// Style de référence : celui du formulaire "Modifier mon profil"
// (CompleteProfileScreen). Cercle subtil 38×38 avec chevron ‹ fin.
//
// Usage :
//   import BackButton from '../components/BackButton';
//   <BackButton onPress={() => navigation.goBack()} />
//
// Pourquoi un composant dédié ?
// Avant, chaque écran définissait son propre bouton retour avec des
// styles divergents (backBtn / backBtnPrem / backNavBtn) — résultat,
// l'expérience utilisateur n'était pas cohérente d'un écran à l'autre.
// Ce composant unifie le pattern et est facile à mettre à jour en un
// seul endroit si on veut faire évoluer le design.

import React from 'react';
import { TouchableOpacity, Text, StyleSheet } from 'react-native';
import { useTheme } from '../context/ThemeContext';

export default function BackButton({ onPress, style, hitSlop }) {
  const { theme } = useTheme();
  const C = theme;

  const dynamicStyles = {
    btn: {
      backgroundColor: C.bgRaised || C.bgSurface || '#F5F4F0',
      borderColor: C.bgBorder || C.border,
    },
    icon: {
      color: C.text,
    },
  };

  return (
    <TouchableOpacity
      onPress={onPress}
      style={[styles.btn, dynamicStyles.btn, style]}
      activeOpacity={0.6}
      hitSlop={hitSlop || { top: 12, bottom: 12, left: 12, right: 12 }}
    >
      <Text style={[styles.icon, dynamicStyles.icon]}>‹</Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  btn: {
    width: 38,
    height: 38,
    borderRadius: 19,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: StyleSheet.hairlineWidth,
  },
  icon: {
    fontSize: 28,
    fontWeight: '300',
    // Léger offset pour centrer optiquement le chevron
    marginLeft: -2,
    marginTop: -2,
  },
});
